import { render, staticRenderFns } from "./region-selection.vue?vue&type=template&id=09781e31&"
import script from "./region-selection.vue?vue&type=script&lang=js&"
export * from "./region-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports